import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { CredentialsService } from '@core/services/credentials.service';
import {
  AiAssistantConversation,
  AiAssistantSendRequest,
  AiAssistantSendResponse,
} from './chatbot.types';

// AI calls (especially knowledge-base answers) can take much longer than normal APIs
export const AI_ASSISTANT_TIMEOUT_MS = 180_000;

const routes = {
  conversation: '/org/sgs/ai-assistant/conversation',
  messages: '/org/sgs/ai-assistant/messages',
};

@Injectable({ providedIn: 'root' })
export class ChatbotService {
  constructor(
    private http: HttpClient,
    private credentialsService: CredentialsService,
  ) {}

  private get authHeaders() {
    return new HttpHeaders({
      Authorization: `Bearer ${this.credentialsService.credentials!.token}`,
    });
  }

  /** Creates or loads the active AI conversation for the authenticated customer. */
  initConversation(): Observable<AiAssistantConversation> {
    return this.http
      .post<AiAssistantConversation>(
        routes.conversation,
        {},
        { headers: this.authHeaders },
      )
      .pipe(timeout(AI_ASSISTANT_TIMEOUT_MS));
  }

  sendMessage(
    payload: AiAssistantSendRequest,
  ): Observable<AiAssistantSendResponse> {
    return this.http
      .post<AiAssistantSendResponse>(routes.messages, payload, {
        headers: this.authHeaders,
      })
      .pipe(timeout(AI_ASSISTANT_TIMEOUT_MS));
  }

  resetConversation(): Observable<void> {
    return this.http.delete<void>(routes.conversation, {
      headers: this.authHeaders,
    });
  }
}
